export enum AttributesConstructorRoutePaths {
  CONSTRUCTOR = '/admin/attributes-constructor',
}
